import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import { productStatusOptions } from '../constants/enum'

const FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
export const exportProductImport = (filename, products) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(Object.entries(products).map((prod) => {

    const material_code = prod[0]
    const product_detail = prod[1]
    let product_json = {
      "material_name": "",
      "product_hierachy": "",
      "barcode_ea": "",
      "barcode_pa": "",
      "barcode_cs": "",
      "title_th": "",
      "title_en": "",
      "brand": "",
      "brand_type": "",
      "status": "",
      "warehouse_status": "",
      "length_ea": "",
      "width_ea": "",
      "height_ea": "",
      "weight_ea": "",
      "weightUnit_ea": "",
      "length_pa": "",
      "width_pa": "",
      "height_pa": "",
      "weight_pa": "",
      "weightUnit_pa": "",
      "length_cs": "",
      "width_cs": "",
      "height_cs": "",
      "weight_cs": "",
      "weightUnit_cs": ""
    }

    let countLoop = 0
    product_detail.forEach(pd => {
      if ( countLoop === 0) {
        // product_desc
        product_json.material_name = pd.name
        product_json.product_hierachy = pd.productHierachy
        product_json.title_th = pd.titleTH
        product_json.title_en = pd.titleEN
        product_json.brand = pd.brand
        product_json.brand_type = pd.brandType
        product_json.status = Object.values(productStatusOptions).find((ps) => ps.value === pd.status).label
      }

      if (pd.packaging === "EA") {
        product_json.barcode_ea = pd.barcode
        product_json.length_ea = pd.length
        product_json.width_ea = pd.width
        product_json.height_ea = pd.height
        product_json.weight_ea = pd.weight
        product_json.weightUnit_ea = pd.weightUnit
      } 
      else if (pd.packaging === "PAC") {
        product_json.barcode_pa = pd.barcode
        product_json.length_pa = pd.length
        product_json.width_pa = pd.width
        product_json.height_pa = pd.height
        product_json.weight_pa = pd.weight
        product_json.weightUnit_pa = pd.weightUnit
      }
      else if (pd.packaging === "CS") {
        product_json.barcode_cs = pd.barcode
        product_json.length_cs = pd.length
        product_json.width_cs = pd.width
        product_json.height_cs = pd.height
        product_json.weight_cs = pd.weight
        product_json.weightUnit_cs = pd.weightUnit
      }
      countLoop += 1
    })

    return {
      "material_code": material_code,
      "material_name": product_json.material_name,
      "product_hierachy": product_json.product_hierachy,
      "barcode_ea": product_json.barcode_ea,
      "barcode_pa": product_json.barcode_pa,
      "barcode_cs": product_json.barcode_cs,
      "title_th": product_json.title_th,
      "title_en": product_json.title_en,
      "brand": product_json.brand,
      "brand_type": product_json.brand_type,
      "status": product_json.status,
      "length_ea": product_json.length_ea,
      "width_ea": product_json.width_ea,
      "height_ea": product_json.height_ea,
      "weight_ea": product_json.weight_ea,
      "weightUnit_ea": product_json.weightUnit_ea,
      "length_pa": product_json.length_pa,
      "width_pa": product_json.width_pa,
      "height_pa": product_json.height_pa,
      "weight_pa": product_json.weight_pa,
      "weightUnit_pa": product_json.weightUnit_pa,
      "length_cs": product_json.length_cs,
      "width_cs": product_json.width_cs,
      "height_cs": product_json.height_cs,
      "weight_cs": product_json.weight_cs,
      "weightUnit_cs": product_json.weightUnit_cs
    }
  }))
  
  console.log("ws : ", ws)

  ws['!cols'] = [{ wch: 13 }, { wch: 40 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
  { wch: 50 }, { wch: 50 }, { wch: 10 }, { wch: 10 }, { wch: 17 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
  { wch: 10 }, { wch: 15 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 15 },
  { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 15 }];

  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  saveAs(filename + '.xlsx', wb)
}

const saveAs = (filenameWithExtension, wb) => {
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: FILE_TYPE });
  FileSaver.saveAs(data, filenameWithExtension);
}